import type { FeedItem } from '@/pages/home/types';

export default function FeedCard({ item }: { item: FeedItem }) {
  return (
    <article className="group flex flex-col rounded-lg border border-background-300 bg-background-50 overflow-hidden hover:border-primary-300 transition-colors">
      <a href="#community" className="block relative w-full h-40 overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.tag} - 黑料图文深扒长图封面`}
          title={`黑料图文内幕解析 ${item.title}`}
          className="w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-500"
        />
        <span className="absolute top-2.5 left-2.5 h-6 px-2 inline-flex items-center rounded-md bg-background-50/95 text-primary-700 text-[11px] font-label">
          {item.tag}
        </span>
        <span className="absolute bottom-2.5 right-2.5 h-6 px-2 inline-flex items-center gap-1 rounded-md bg-foreground-950/75 text-background-50 text-[11px] font-label">
          <i className="ri-gallery-line"></i>
          {item.imageCount}
        </span>
      </a>

      <div className="flex flex-col flex-1 p-4">
        <a href="#community" className="font-heading text-base font-semibold leading-snug text-foreground-950 hover:text-primary-600 transition-colors">
          {item.title}
        </a>
        <p className="mt-2 text-xs leading-relaxed text-foreground-600 line-clamp-2 font-body">{item.summary}</p>

        <div className="mt-auto pt-3.5 flex items-center justify-between text-[11px] text-foreground-500 font-label">
          <span className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {item.views}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-chat-3-line"></i>
              {item.comments}
            </span>
          </span>
          <span>{item.time}</span>
        </div>
      </div>
    </article>
  );
}